import _ from "lodash";
import { useMemo } from "react";

import { API_ENDPOINTS } from "../../api/constants";
import useFetch from "../../api/useFetch";

/*
 * The user's watchlist row for `company`, or undefined if it isn't watched.
 *
 * The ZX watchlist endpoint is JSON:API, so rows live under `cleanedData.data` and
 * a DELETE must use the row id (`apiId`), not the company zb_id — the same contract
 * the screener uses (ZX-15338).
 */
const useWatchlistEntry = (company, companyIsLoading) => {
  const watchlistQueryInfo = useFetch(API_ENDPOINTS.WATCHLIST_COMPANIES());

  return useMemo(
    () =>
      watchlistQueryInfo.isSuccess && !companyIsLoading && company?.zb_id
        ? _.find(watchlistQueryInfo.cleanedData?.data, { company: company.zb_id })
        : undefined,
    [watchlistQueryInfo, company, companyIsLoading]
  );
};

export default useWatchlistEntry;
